import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appAlphanumericInput]',
})
export class AlphanumericInputDirective {

  constructor(private readonly el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: KeyboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;

    // Mevcut değeri al
    let value = input.value;

    // Harfleri büyük yap
    value = value.toUpperCase();

    // Sadece alfanümerik karakterleri (büyük harf ve rakam) kabul et
    value = value.replaceAll(/[^A-Z0-9]/g, '');

    // Değeri inputa yeniden ata
    input.value = value;

    // Değişiklik sonrasında input değerini güncelle
    event.preventDefault();
  }

}
